

// export const membershipApplicationNames = [
//     { title: 'Life Members [lm] - INDIA & SAARC',slug: 'life-member' },
//     { title: 'International Life Members [ILM]',slug: 'international-life-member' },
//     { title: 'Associate Life Member [ALM]',slug: 'associate-life-member' },
//     { title: 'Associate Candidate Member [ACM]',slug: 'associate-candidate-member' },
//     { title: 'ALM to LM conversion',slug: 'alm-to-lm' },
//     { title: 'ACM to LM conversion',slug: 'acm-to-lm' },
// ];

export const membershipApplicationStatisticscardData = [
    { id:1, title: "All Applications", count: 4028, progress: 47 },
    { id:3, title: "Pending Actions", count: 4028, progress: 47 },
    { id:12, title: "Membership Number Allotted", count: 4028, progress: 47 },
    { id:4, title: "Pending Resubmission", count: 4028, progress: 47 },
    { id:2, title: "Pending Clarification", count: 4028, progress: 47 },
    { id:10, title: "Payment Status", count: 4028, progress: 47 },
    { id:6, title: "Rejected", count: 4028, progress: 47 },
    { id:13, title: "Void", count: 4028, progress: 47 },
    { id:15, title: "Active Members", count: 4028, progress: 47 },
    { id:7, title: "Inactive Members", count: 4028, progress: 47 },
    { id:0, title: "Incomplete Applications", count: 4028, progress: 47 },
];

// export function convertDBDate(dateStr){    
//     const formattedDate = new Date(dateStr).toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//     });
//     return formattedDate;
// }
export function convertDBDate(dateStr) {
  if (!dateStr) return "N/A";

  const date = new Date(dateStr);

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "UTC"
  }).format(date);
}


// export function convertCertificateDate(dateStr) {    
//   const date = new Date(dateStr);
//   const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
//   return formattedDate;
// }
export function convertCertificateDate(dateStr) {
  if (!dateStr) return "N/A";

  const date = new Date(dateStr);
  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // UTC month is 0-based
  const year = date.getUTCFullYear();

  return `${day}-${month}-${year}`;
}

